import React, { useState } from 'react';
import { withStyles } from '@material-ui/core';
import { Alert } from '@ds/react-components';
import PageWrapper from 'components/ui/PageWrapper';
import {
  getSuspensionAlertMessage,
  removeSuspensionAlertMessage,
} from 'utils/suspensions';

const styles = (theme) => ({
  Container: {
    paddingBottom: '0px',
  },
  Title: {
    margin: '0px',
    fontWeight: '500',
    fontSize: '14px',
    lineHeight: '20px',
  },
  Warning: {
    color: theme.palette.common.black,
  },
  List: {
    listStyleType: 'disc',
    margin: '0px',
    padding: '0px 0px 0px 20px',
  },
  //TODO: Need update Alert in ds-react lib, then we can remove the style.
  success: {
    borderLeftColor: theme.palette.xpl.green600,
    backgroundColor: theme.palette.xpl.message.positive.background,
    color: theme.palette.common.black,
    '& h3': {
      color: theme.palette.common.black,
    },
    '& svg': {
      color: theme.palette.xpl.green600,
    },
  },
});

const SuspensionAlertMessage = (props) => {
  const { classes } = props;
  const message = getSuspensionAlertMessage();
  const [showAlert, setShowAlert] = useState(!!message);
  const warnings = message?.response?.warnings || [];
  removeSuspensionAlertMessage();

  return (
    <>
      {showAlert ? (
        <PageWrapper className={classes.Container}>
          <Alert
            className={classes[message?.variant]}
            role="banner"
            variant={message?.variant}
            onClose={() => setShowAlert(false)}>
            <h3 className={classes.Title}>{message?.title}</h3>
            {warnings.length > 0 ? (
              <>
                <br />
                <div className={classes.Warning}>warning</div>
                <ul className={classes.List}>
                  {warnings.map((warning, index) => (
                    <li key={index}>{warning}</li>
                  ))}
                </ul>
              </>
            ) : (
              <></>
            )}
          </Alert>
        </PageWrapper>
      ) : (
        <></>
      )}
    </>
  );
};

export default withStyles(styles)(SuspensionAlertMessage);
